/**
 * Class to render nodes utils
 * @author Daniel Santos <daniel.santos@gradiweb.com>
 */
class RenderElements {
  /**
   * Render HTML component and Choose render position.
   * Positions:
   * beforebegin
   * afterbegin
   * beforeend
   * afterend
   * @param {Node} parent - Parent node where to render
   * @param {String} textNode - Text node to render
   * @param {String} position - Position of render of the textNode based parent
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  renderTextNodes = (parent, textNode, position = 'beforeend') => {
    parent.insertAdjacentHTML(position, textNode);
  };
}

export { RenderElements };
